import { useQuery } from '@tanstack/react-query';
import { FieldPath, FieldValues } from 'react-hook-form';

import { useProductCenterApi } from 'api';
import { telephoneCountryCodesQuery } from 'api/queries';
import { mapTelephoneCountryCodeToIdLabel } from 'api/responses/models/Configuration/TelephoneCountryCodeDto';
import {
	ControlledAutocomplete,
	ControlledAutocompleteProps,
} from 'library/components/controls/form/ControlledAutocomplete';
import { Option } from 'library/models/Option';

export type PhonePrefixInputProps<
	TFieldValues extends FieldValues = FieldValues,
	TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<
	ControlledAutocompleteProps<Option<string>, TFieldValues, TName>,
	'options'
>;

export const PhonePrefixInput = <
	TFieldValues extends FieldValues = FieldValues,
	TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
	props: PhonePrefixInputProps<TFieldValues, TName>
): React.JSX.Element => {
	const { api } = useProductCenterApi();
	const { data } = useQuery(telephoneCountryCodesQuery(api));

	const phonePrefixOptions = data?.map(mapTelephoneCountryCodeToIdLabel);

	return (
		<ControlledAutocomplete options={phonePrefixOptions || []} {...props} />
	);
};
